import { Box, Tab } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import Text from 'components/_core/Text';

const PlanTab: FCWithChildren = ({ children, ...props }) => {
  return (
    <Tab {...props}>
      <Box paddingX="space-16" paddingY="space-12" width={{ md: '8.8125rem' }}>
        <Text variant="primary">{children}</Text>
      </Box>
    </Tab>
  );
};

export default PlanTab;
